var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRwf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3591)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V13.4167H23V0H0Z",
    fill: "#3AA4D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.25V23H23V17.25H0Z",
    fill: "#5A972B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3088 11.371C17.285 11.3718 17.2611 11.3722 17.2371 11.3722C17.2166 11.3722 17.1961 11.3719 17.1757 11.3713L16.7412 13.263L16.6493 11.2926C16.6053 11.2805 16.5617 11.2671 16.5184 11.2524L15.7661 12.9581L16.0208 11.0159C15.9798 10.9905 15.9393 10.9638 15.8994 10.936L14.8705 12.365L15.4573 10.5549C15.4215 10.5174 15.3865 10.4789 15.3522 10.4393L14.1029 11.5154L14.9887 9.93534C14.9601 9.88762 14.9324 9.83896 14.9056 9.78941L13.5044 10.4552L14.6403 9.1898C14.6206 9.13404 14.602 9.07754 14.5843 9.02034L13.1075 9.24159L14.4323 8.35693C14.423 8.29634 14.4147 8.23523 14.4076 8.17362L12.9335 7.93996L14.3765 7.48237C14.3779 7.41977 14.3806 7.35756 14.3844 7.29577L12.9917 6.62049L14.4745 6.61413C14.4869 6.5535 14.5005 6.49349 14.5152 6.43412L13.2792 5.3543L14.7232 5.79916C14.746 5.74423 14.7698 5.69012 14.7945 5.63689L13.7802 4.20967L15.1087 5.08248C15.1403 5.03625 15.1727 4.99106 15.206 4.94694L14.4679 3.24829L15.6087 4.50239C15.6473 4.46713 15.6866 4.4331 15.7265 4.40033L15.3052 2.522L16.1964 4.09012C16.2399 4.06773 16.284 4.0467 16.3285 4.02708L16.2469 2.06994L16.8406 3.86905C16.8864 3.86069 16.9326 3.85375 16.9791 3.84828L17.2423 1.9165L17.5056 3.84954C17.5519 3.85521 17.5978 3.86233 17.6434 3.87086L18.2376 2.06994L18.1559 4.03159C18.1997 4.05113 18.243 4.07203 18.2858 4.09426L19.1793 2.522L18.7564 4.40753C18.7953 4.43969 18.8336 4.47305 18.8712 4.50756L20.0166 3.24829L19.2748 4.95568C19.3069 4.99852 19.3382 5.04237 19.3687 5.08718L20.7043 4.20967L19.6837 5.64571C19.7074 5.69702 19.7303 5.74912 19.7521 5.80199L21.2054 5.3543L19.9608 6.44157C19.9748 6.49849 19.9878 6.55601 19.9997 6.61408L21.4928 6.62049L20.0901 7.30065C20.0937 7.35975 20.0962 7.41923 20.0977 7.47906L21.5511 7.93996L20.0664 8.17529C20.0595 8.23421 20.0517 8.29267 20.0428 8.35066L21.3771 9.24159L19.8903 9.01886C19.8734 9.07373 19.8556 9.12796 19.8368 9.18151L20.9801 10.4552L19.5708 9.78549C19.5449 9.8333 19.5183 9.88028 19.4908 9.92639L20.3817 11.5154L19.1265 10.4342C19.0932 10.4727 19.0593 10.5103 19.0247 10.5467L19.614 12.365L18.5817 10.9312C18.5426 10.9586 18.5031 10.9848 18.463 11.0099L18.7185 12.9581L17.9648 11.2493C17.922 11.264 17.8789 11.2775 17.8354 11.2897L17.7434 13.263L17.3088 11.371ZM17.2112 9.98072C18.2179 9.98072 19.034 8.90844 19.034 7.5857C19.034 6.26297 18.2179 5.19069 17.2112 5.19069C16.2045 5.19069 15.3885 6.26297 15.3885 7.5857C15.3885 8.90844 16.2045 9.98072 17.2112 9.98072ZM18.2596 7.65582C18.2596 8.41227 17.7997 9.0255 17.2323 9.0255C16.665 9.0255 16.2051 8.41227 16.2051 7.65582C16.2051 6.89936 16.665 6.28614 17.2323 6.28614C17.7997 6.28614 18.2596 6.89936 18.2596 7.65582Z",
    fill: "#FFDD1A"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3591)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3591",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwf);
export default __webpack_public_path__ + "static/media/RWF.0e1fd1100baac2339b1f909dc57f9160.svg";
export { ForwardRef as ReactComponent };